import React from 'react'
import { withJsonFormsControlProps } from '@jsonforms/react';
import { Form, Select } from 'antd'
import type { Rule } from "antd/es/form"
import WithLabel from '../../ui/WithLabel/WithLabel';
import { AppEnumControlUISchema } from '../form-types';
import { ControlElement, ControlProps as JSFControlProps } from '@jsonforms/core';
import { FormIcon } from '../icon';
import { useFormValue } from '../hooks/useFormValue';

type ControlProps = Omit<JSFControlProps, "uischema"> & {
  uischema: AppEnumControlUISchema<unknown> | ControlElement
}

const SelectControl: React.FC<ControlProps> = ({
  label,
  data,
  path,
  enabled,
  required,
  schema,
  uischema,
  handleChange,
}) => {
  const { enum: values = [], default: defaultValue } = schema ?? {};
  const { columns = 1, enumValueToLabelMap = {}, icon, extraRules } = uischema.options ?? {};

  const initialData = useFormValue({
    path,
    value: data,
    initialValue: data || defaultValue || null,
    handleChange
  })

  const rules: Rule[] = [
    { required, message: `${label} is required` },
    ...(extraRules ?? [])
  ]

  return (
    <Form.Item
      name={path}
      rules={rules}
      initialValue={initialData}
      validateTrigger='onSubmit'
      validateFirst
      style={{
        gridColumn: `span ${columns}`,
      }}
      getValueFromEvent={(value) => {
        handleChange(path, value);
        return value;
      }}
    >
      <WithLabel
        icon={<FormIcon name={icon} size={18} />}
        label={label}
        required={required}
      >
        <Select
          getPopupContainer={() => document.getElementById('App') || document.body}
          disabled={!enabled}
        >
          {values.map((v) => (
            <Select.Option value={v} key={v}>
              {enumValueToLabelMap[v] ?? v}
            </Select.Option>
          ))}
        </Select>
      </WithLabel>
    </Form.Item>
  )
};

export default withJsonFormsControlProps(SelectControl as any);
